// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text__hint[data-v-46b016bf]{font-size:10px;font-weight:400;line-height:1.5;letter-spacing:normal}.text__hint.bold[data-v-46b016bf]{font-weight:700}", ""]);
// Exports
module.exports = exports;
